var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9A",
    stroke: "none",
    d: "M15.464,59.6264c0.1391-0.1691,2.3559-7.8264,2.8998-9.627c0.457-1.5137,3.9618-15.2702,6.1601-25.071 c0.0084-0.1315,33.4839-0.6133,33.4839-0.6133v-4.0109c0,0.5522-1-3.356-1-3.356L29.5147,16.377 c-0.0801-1.2364-1.004-4.1216-2.1368-4.1216L14.791,12.0571c-1.1026,0-2.8321,1.3407-2.8321,2.4437c0,0,0.5527,39.7248,0,39.7248 c-0.5527,0-0.9999,2.3271-0.9999,1.7744c0,0,0.3537,3.5947,1.3755,4.566c0.0143,0.0137,0.0302,0.0212,0.0451,0.0335 C12.2471,60.4436,15.305,59.8189,15.464,59.6264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0CFCE",
    stroke: "none",
    d: "M23.9444,24.3151c0,0.0782-0.0083,0.1557-0.0259,0.2318c-0.2749,1.226-6.7345,30.0417-7.363,32.1243 c-0.3359,1.1164-0.9593,2.3082-1.7645,3.291l43.1115,0.0104c1.1381,0,1.5216,0,2.1521-2.3899 c0.6676-2.5305,6.6984-30.2693,7.342-33.2323c0.0017-0.009,0.0066-0.0353,0.0066-0.0353H23.9444z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M57.0078,20.3044v-3.3562l-27.3383-0.0025c-0.198,0-0.3586-0.165-0.3586-0.3684l-0.0687-1.5169 c-0.116-1.7878-1.3398-3.0033-2.9967-3.0033H14.9589c-1.6569,0-3,1.3432-3,3V56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17.0271,55.5678c-0.5897,1.954-2.2223,4.1389-3.8959,4.394l43.9148,0.0108c1.6569,0,2.3233-0.4388,3-3 c0.6767-2.5612,7-31.6575,7-31.6575c0-0.5523-0.4477-1-1-1H24.9649c-0.5523,0-1,0.4477-1,1 C23.9649,25.3151,17.6168,53.6137,17.0271,55.5678z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.0aa3143f6111d4a05caa2bea7f8ad0bd.svg";
export { ForwardRef as ReactComponent };